import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://srv.bnow.site',
    timeout: 60000
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    config.headers['X-Access-Token'] = token ? token : undefined;
    return config;
}, (error) => {
	return Promise.reject(error);
});

api.interceptors.response.use((response) => {
	return response;
}, (error) => {
	return Promise.reject(error.response);
});